// extracted by mini-css-extract-plugin
export default {"spinnerPosition":"_3pmUO","errorTemplate":"_1pMFk","errorDetails":"W9RxG","logoNotFound":"_1py21"};